import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareLines: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareLines"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM16 11H8V9H16V11ZM8 15H14V13H8V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareLines;
